import React, { ReactNode } from 'react';

import Container from '@src/components/reusable/Container';

import { ErrorContainer, Content } from './styles';

type ErrorProps = {
  children: ReactNode;
};

export const Error = (props: ErrorProps) => {
  const { children } = props;

  return (
    <ErrorContainer>
      <Container>
        <Content>{children}</Content>
      </Container>
    </ErrorContainer>
  );
};

export default Error;
